export default __webpack_public_path__ + "static/media/instagram_szkielet.41635b0d.jpg";